module.exports = __webpack_public_path__ + "img/code.08e58393.svg";